<template>
  <div class="transferBox">
    <headerBack :backParams="backParams" @backBtn="backBtn()"></headerBack>
    <div class="search-input">
      <div class="input-box">
        <input type="text" ref="input" class="input" placeholder="请输入搜索关键字" v-model="keyWord" @input="inputChange(keyWord)">
      </div>
      <div class="iconfont icon-shanchu1" @click="clearKey" v-show="keyWord.length"></div>
    </div>
    <div class="search-map">
      <div class="map-item">
        <div class="my-position iconfont icon-wodeweizhi" @click="myPosition"> 我的位置</div>
      </div>
      <div class="map-item" @click="mapDtag">
        <div class="my-position iconfont icon-dituxuandian"> 地图选点</div>
      </div>
    </div>
    <div class="title" v-if="resultList.length"><div class="line"></div>查询数据</div>
    <div class="search-wrapper" v-if="resultList.length">
      <div class="station" v-for="(item, index) in resultList" :key="index" @click="saveStation(item, '1')">
        <div class="iconfont icon-weizhi"></div>
        <div class="search-item">
          <div class="name">{{item.name}}</div>
          <div class="address">{{item.address}}</div>
        </div>
      </div>
    </div>
    <div class="title" v-if="historyData.length && !resultList.length"><div class="line"></div>历史记录</div>
    <div class="search-wrapper" v-if="historyData.length && !resultList.length">
      <div class="station" v-for="(item, index) in historyData" :key="index" @click="saveStation(item, '2')">
        <div class="iconfont icon-weizhi"></div>
        <div class="search-item">
          <div class="name">{{item.name}}</div>
          <div class="address">{{item.address}}</div>
        </div>
      </div>
      <div class="clear-history" @click="clearHisory">清空历史记录</div>
    </div>
    <div class="no-data">
      <div class="iconfont icon-wushuju"></div>
      <div class="word">暂无数据~</div>
    </div>
  </div>
</template>

<script>
import throttle from '@/utils/throttle'
import AMap from 'AMap'
import AMapUI from 'AMapUI'
import wx from 'weixin-js-sdk'
import {setLocalStorage, getLocalStorage} from '@/utils/session.js'
import headerBack from '@/components/headerBack'
export default {
  name: "searchStation",
  components: {
    AMap,
    AMapUI,
    headerBack
  },
  data () {
    return {
      backParams:{
        title:'站点搜索'
      },
      searchType: '',
      keyWord: '',
      resultList: [], // 搜索结果
      historyData: [],
      isShowBack: true,
      latLng:{},
    }
  },
  mounted () {
    this.latLng = getLocalStorage('LatLng')
    this.isShowBack = this.isAndroid_ios()
    this.searchType = this.$session.getLocalStorage('searchType') || this.$route.params.searchType
    this.getHistory()
    this.$wxHide()
  },
  methods: {
    // 判断是否是安卓还是ios
    isAndroid_ios () {
      let u = navigator.userAgent
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
      return isAndroid === true
    },
    backBtn () {
      this.$router.push({name: 'transfer'})
    },
    inputChange: throttle(function(keyWord) {
      this.autoInput(keyWord)
    }, 1000),
    // 获取搜索信息
    autoInput (keyWord) {
      AMap.plugin('AMap.PlaceSearch', () => {
        var autoOptions = {
          city: this.$cityCode.city,
          children: 1,
          pageSize: 20
        }
        var placeSearch = new AMap.PlaceSearch(autoOptions)
        placeSearch.search(keyWord, (status, result) => {
          // 搜索成功时，result即是对应的匹配数据
          if (result.info === 'OK') {
            this.resultList = result.poiList.pois
          }
        })
      })
    },
    saveStation (item, str) {
      const params = {
        type: this.searchType,
        name: item.name,
        address: item.address,
        lat: str === '1' ? item.location.lat : item.lat,
        lng: str === '1' ? item.location.lng : item.lng
      }
      this.historyData.unshift(params)
      this.$session.setLocalStorage('historySearch', this.historyData)
      // 根据查询的起始和终点缓存相应的数据，以备后期使用
      if (this.searchType === 'start') {
        this.$store.dispatch('save_startStation', params)
      } else {
        this.$store.dispatch('save_endStation', params)
      }
      this.$router.push({name: 'transfer', params: {backSearchObj: params}})
    },
    getHistory () {
      let storageData = this.$session.getLocalStorage('historySearch')
      if (storageData) {
        if (storageData.length) {
          let arr = [storageData[0]]
          for (let i = 1; i < storageData.length; i++) {
            var repeatData = false
            for (var j = 0; j < arr.length; j++) {
              if (storageData[i]['name'] === arr[j]['name'] && storageData[i]['address'] === arr[j]['address']) {
                repeatData = true
                break
              }
            }
            if (!repeatData) {
              arr.push(storageData[i])
            }
          }
          this.historyData = arr
        } else {
          this.historyData = []
        }
      }
    },
    clearHisory () {
      this.$session.removeLocalStorage('historySearch')
      this.historyData = []
    },
    clearKey () {
      this.keyWord = ''
      this.resultList = []
      this.$refs.input.focus()
    },
    mapDtag () {
      this.$router.push({name: 'mapDragPoint', params: {searchType: this.searchType }})
    },
    myPosition () {
      let lat =this.latLng.lat
      let lng =this.latLng.lng
      this.saveMyPositon(lat,lng)
      // let latAndLng = this.$session.getLocalStorage('latAndLng') || {}
      // if (latAndLng && latAndLng.lat && latAndLng.lng) {
      //   this.saveMyPositon(latAndLng.lat, latAndLng.lng)
      // } else {
      //   wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
      //     wx.getLocation({
      //       type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      //       success: (res) => {
      //         const position = {
      //           lat: res.latitude,
      //           lng: res.longitude
      //         }
      //         this.$session.setLocalStorage('latAndLng', position)
      //         this.saveMyPositon(res.latitude, res.longitude)
      //       }
      //     })
      //   })
      // }
    },
    saveMyPositon (lat, lng) {
      const params = {
        type: this.searchType,
        name: '我的位置',
        address: '',
        lat: lat,
        lng: lng
      }
      // 根据查询的起始和终点缓存相应的数据，以备后期使用
      if (this.searchType === 'start') {
        this.$store.dispatch('save_startStation', params)
      } else {
        this.$store.dispatch('save_endStation', params)
      }
      this.$router.push({name: 'transfer', params: {backSearchObj: params}})
    }
  }
};
</script>

<style lang="scss" scoped>
.transferBox {
  background: #F8F8F8;
  height: 100%;
  overflow: hidden;
  .search-input {
    width: 100%;
    height: 50px;
    background: #ffffff;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    .back-left {
      width: 30px;
      height: inherit;
      text-align: center;
      line-height: 50px; 
    }
    .input-box {
      flex: auto;
      text-align: center;
      height: inherit;
      display: flex;
      align-items: center;
      margin-left: 20px;
      .input {
        width: 100%;
        height: inherit;
        line-height: 50px;
        font-size: 16px;
        border: none;
        box-sizing: border-box;
      }
    }
    .iconfont {
      width: 30px;
    }
  }
  .search-map {
    width: 100%;
    height: 45px;
    background: #ffffff;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    .map-item {
      width: 50%;
      color: #1989fa;
      display: flex;
      align-items: center;
      justify-content: center;
      &.map-item:first-child {
        border-right: 1px solid  #eeeeee;
      }
    }
  }
  .title {
    width: auto;
    height: 35px;
    line-height: 35px;
    background: #F8F8F8;
    padding: 0px 5px;
    font-size: 16px;
    color: #999999;
    display: flex;
    align-items: center;
    .line {
      width: 3px;
      height: 20px;
      background: #1989fa;
      margin-right: 5px;
    }
  }
  .search-wrapper {
    width: 100%;
    height: calc(100vh - 130px);
    background: #ffffff;
    overflow: auto;
    .station {
      width: auto;
      height: 50px;
      margin-left: 10px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid  #eeeeee;
      .iconfont {
        color: #1989fa;
      }
      .search-item {
        flex: 1 auto;
        margin-left: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
        .name {
          font-size: 16px;
          color: #000000;
        }
        .address {
          font-size: 14px;
          color:#666666;
        }
      }
    }
    .clear-history {
      width: auto;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #666666;
      border-bottom: 1px solid  #eeeeee;
    }
  }
  .no-data {
    width: 100%;
    height: calc(100vh - 100px);
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    .iconfont {
      font-size: 100px;
      margin: 20vh auto 10px;
      color: #999999;
    }
    .word {
      font-size: 14px;
      color: #999999;
    }
  }
}
</style>
